const Card = ({ children, className = '', onClick, ...props }) => (
  <div
    className={`bg-white border border-zinc-200 rounded-lg shadow-[0_2px_8px_rgba(0,0,0,0.04)] ${onClick ? 'cursor-pointer' : ''} ${className}`}
    onClick={onClick}
    {...props}
  >
    {children}
  </div>
);

export default Card;
